export const DEATH_TIPS: readonly string[] = [
  'When you upgrade, the ship upgrade cost lowers.',
  'Sometimes, drones will take hits for you.',
  'Players get between 2 and 8 credits at the end of the game, based on their score.',
  'Kills, assists, deaths, healing, damage to base, and team swapping all affect score.',
  'Right click uses your special ability. Using it often gets you the upper hand in fights.',
  'Emojis are used with 0-9. Hover over the emoji in the bottom left to see what keys do.',
  'Each time you die, a new tip appears here. Like this one. Which you are reading.',
  'When a player dies, the base takes a point of damage preparing their revival.',
  "Different upgrade paths lead to different ships. For example, you can't be a mechanic if you go heavy.",
  'For fairness, trails are only shown to team mates, but tags and decals are shown to all.',

  'Some products can only be obtained using a redeem code.',
  "Everything in the game is purchasable without spending a cent. It'll just take time, is all.",
  'Decals go over every ship.',
  'Tags are interesting. Especially the commander tag.',
  "See something in-game you can't get? That's because it's either a clan image, or a unique one.",
  'That rainbow trail is so very majestic.',
  'When life gives you a lemon, equip it, and make sure to thank life.',
  'Ship skins are per-ship. To get all the halloween set for example, you need to buy it on each ship.',

  "As the Engi, spawning drones lowers it's ship upgrade cost.",
  "The mechanic's healing pods can also heal turrets, and even the base!",
  'Newer players will probably like the utility ship tree more, because of passive scrap.',
  "At the doctor's fastest, it is more than twice as fast as the starter ship.",
  'Sniper shot deals high damage to the closest enemy to your mouse. Good for picking off low health targets.',
  "Getting shot by something off-screen? It's probably a sniper turret.",
  'Drones are weak against lots of small hits, like from other drone ships!',
  'Stealth ends early if you attack!',
  "The wall is an utter beast. It's ok in the heat of battle, but fantastic if planned for.",
  'B.R.U.C.E Stands for <Classified information>',
  'D.o.D Stands for <Classified information>',
  'M.o.D Stands for <Classified information>',

  'It is wise to upgrade while the ship upgrade price is more than 0.',
  'Turrets counter suicide drones!',
  'Having trouble with turret bases? Try timed shield, or damage in radius.',
  "Simply rushing at the enemy base isn't a good strategy. Grouping up definitely is.",
  'Two ships are better than one. Warin.space is a team game, so, fight in teams!',
  'When games are close, sometimes defending is just as offensive as attacking!',
  "Passive scrap is good. It's really, really good.",
  "Upgrade wisely. There are a ton of synergies, and once you upgrade, there's no going back.",
  'Sometimes, you may want to wait before upgrading, if your current ship gets scrap faster.',
  'Turrets are great at putting off chasers.',
  "Swapping to the enemy team because it's winning is foolish. You immediately lose 50 score.",
  'You deal the same damage regardless of health. Therefore, if you are low, move behind others!',
  "You lose scrap when dying, but can't go into negatives, so, it's good to upgrade just before dying.",

  'The war over the element Kairus-52 rages on.',

  'Emojis may be difficult to communicate with. But, you can also use your name.',
  'Avoid profanity/insults in names, warin is played by all ages.',
  'Random, silly names are great, but becoming a known player in the community is better.',
  'The black separators in health bars indicate blocks of 100 health.',
  "Don't worry! Dying is just part of the game, it happens to the best!",

  'Monocle decal: Well sir, I do say!',
  'The devs saw that..',
  '0118999 88199 9119725... 3',
  'Is it Easter yet?',
];
